import "./feature.scss";
import { useNavigate } from "react-router-dom";
import { ReactComponent as NoteIcon } from "../../assets/icons/Note.svg";

const FeatureCard = ({
  name,
  subtitle,
  disabled,
  firstButtonName,
  FirstButtonIcon,
  firstButtonRedirect,
  firstButtonDisabled,
  secondButtonName,
  SecondButtonIcon,
  secondButtonRedirect,
  secondButtonDisabled,
  documentationLink,
  showDocumentation,
}) => {
  const navigate = useNavigate();

  const redirectTo = (redirectLink) => {
    if (redirectLink.startsWith("http")) {
      window.open(redirectLink, "_blank");
    } else {
      navigate(redirectLink);
    }
  };

  return (
    <div className={`feature-card ${disabled ? "disabled-card" : ""}`}>
      <p className={"title"}>
        {name} {disabled ? <span>(coming soon)</span> : <></>}
      </p>
      <p className="subtitle" style={{fontSize: '14px'}}>
            {subtitle}
            </p>
      <div className={"test-deploy-buttons"}>
        <button
          onClick={() => redirectTo(firstButtonRedirect)}
          disabled={firstButtonDisabled}
        >
          <FirstButtonIcon />
          <p>{firstButtonName}</p>
        </button>
        <button
          onClick={() => redirectTo(secondButtonRedirect)}
          disabled={secondButtonDisabled}
        >
          <SecondButtonIcon />
          <p>{secondButtonName}</p>
        </button>
      </div>
      {showDocumentation && (
        <div
          onClick={() => window.open(documentationLink, "_blank")}
          className={`link ${!documentationLink ? "link-disabled" : ""}`}
        >
          <NoteIcon />
          <p>View Documentation</p>
        </div>
      )}
    </div>
  );
};

export default FeatureCard;